import { gql } from 'graphql-request';

import {
  baseApi,
  select,
  insert,
  update,
  afterUpdate,
  afterInsert,
  remove,
  afterRemove,
} from './base';

import { uniclassType } from '../graphqlTypes';

const uniclassApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUniclassFilter: select(builder, 'uniclass', uniclassType, false, {
      filter: (params) =>
        `{${params.payload.id ? `id: {_ilike: "${params.payload.id}"},` : ''}
          ${params.payload.title ? `title: {_ilike: "${params.payload.title}"},` : ''}  
         }`,
      order: `{id: asc}`,
      cacheKey: (params) => params?.queryArgs?.cacheKey,
    }),
    getUniclass: select(builder, 'uniclass', uniclassType, true),
    updateUniclass: update(builder, 'uniclass', uniclassType, afterUpdate('getUniclassFilter')),
    insertUniclas: insert(builder, 'uniclass', uniclassType, afterInsert('getUniclassFilter')),
    removeUniclass: remove(builder, 'uniclass', uniclassType, afterRemove('getUniclassFilter')),
  }),
  overrideExisting: false,
});

export const {
  useGetUniclassFilterQuery,
  useGetUniclassQuery,
  useUpdateUniclassMutation,
  useInsertUniclasMutation,
  useRemoveUniclassMutation,
} = uniclassApi;
